import Collapse from 'antd/es/collapse/Collapse';
import Typography from 'antd/es/typography';
import React, { Suspense, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { statusHelper } from 'src/app/helpers';
import { pageActions } from 'src/app/redux/actions';

const ProductLicenses = () => {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const { Panel } = Collapse;

  const [licenseData, setLicenseData] = useState<any[]>([]);

  const collapseItems = useMemo(() => {
    dispatch(pageActions.setActivePage(''));

    return licenseData.map((o: any) => ({
      key: o.library,
      label: (
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 2, minWidth: 0 }}>
            <Typography.Text
              style={{
                color: 'rgba(255,255,255,0.92)',
                fontWeight: 700,
                fontSize: 15,
                lineHeight: 1.2,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              {o.library}
            </Typography.Text>
            <Typography.Text
              style={{
                color: 'rgba(255,255,255,0.72)',
                fontSize: 12,
                lineHeight: 1.2,

                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              {o.description === 'N/A' ? 'No Description Included for this Package' : o.description}
            </Typography.Text>
          </div>
        </div>
      ),
      children: (
        <div
          style={{
            background: 'rgba(0,0,0,0.18)',
            border: '1px solid rgba(255,255,255,0.10)',
            borderRadius: 14,
            padding: 14,
            height: '500px',
            maxHeight: '35vh',
            overflowY: 'auto',
            whiteSpace: 'pre-line',
          }}
        >
          <Typography.Text
            style={{
              color: 'rgba(255,255,255,0.92)',
              fontWeight: 700,
              fontSize: 15,
              lineHeight: 1.2,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              textAlign: 'center',
            }}
          >
            {o.licenseType}
          </Typography.Text>
          <Typography.Text style={{ color: 'rgba(255,255,255,0.72)', display: 'block', marginTop: 10 }}>
            {o.licenseText}
          </Typography.Text>
        </div>
      ),
    }));
  }, [licenseData, t]);

  useEffect(() => {
    const setData = async () => {
      try {
        const urls = ['/client_licenses.json', '/backend_licenses.json', '/storage_licenses.json'];

        const res = await Promise.all(urls.map((url) => fetch(url)));
        const resJson = await Promise.all(res.map((r) => r.json()));

        const mappedArray = [...resJson[0], ...resJson[1], ...resJson[2]];

        const unique: any[] = [];

        const nonUnique: any[] = [];

        for (let i = 0; i < mappedArray.length; i += 1) {
          if (!unique[mappedArray[i].library]) {
            nonUnique.push(mappedArray[i]);
            unique[mappedArray[i].library] = 1;
          }
        }
        setLicenseData(nonUnique);
      } catch (error: any) {
        statusHelper.displayErrorMessage(error.message);
      }
    };
    setData();
  }, []);

  if (licenseData.length === 0) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          color: 'white',
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%,-50%)',
        }}
      >
        {t('general.loading')}
      </div>
    );
  }

  return (
    <Suspense fallback="...Loading">
      <div style={{ width: '100%', height: '100%', overflow: 'scroll' }}>
        <div
          style={{
            position: 'sticky',
            top: 0,
            zIndex: 5,
            padding: '10px 18px 12px 18px',
            background: 'rgba(63,63,63,0.92)',
            borderBottom: '1px solid rgba(255,255,255,0.10)',
            backdropFilter: 'blur(8px)',
          }}
        >
          <div style={{ maxWidth: 980, margin: '0 auto' }}>
            <Typography.Title level={4} style={{ margin: 0, color: 'rgba(255,255,255,0.92)', textAlign: 'center' }}>
              Third Party Licenses and Dependencies
            </Typography.Title>
            <Typography.Paragraph style={{ margin: 0, color: 'rgba(255,255,255,0.92)', textAlign: 'center' }}>
              Monitor the third party libraries and underlying dependencies.
            </Typography.Paragraph>
          </div>
        </div>

        <div style={{ width: '100%', height: 'calc(100%-86px)', overflow: 'auto', padding: 18 }}>
          <div style={{ maxWidth: 980, margin: '0 auto' }}>
            <Collapse
              accordion
              destroyInactivePanel
              style={{
                width: '100%',
                borderRadius: 18,
                overflow: 'hidden',
                border: '1px solid rgba(255,255,255,0.12)',
                background: 'rgba(255,255,255,0.06)',
              }}
            >
              {collapseItems.map((item, index) => (
                <Panel header={item.label} key={index}>
                  {item.children}
                </Panel>
              ))}
            </Collapse>
          </div>
        </div>
      </div>
    </Suspense>
  );
};

export default ProductLicenses;
